<template>
  <div>
    <form novalidate @submit.prevent="validateAndSave()">
      <div>
        <p>Patient {{ patient.hospital_id }}  / {{ patient.name }} / Antibiotics <span v-for="(antibiotic, index) in antibiotics" :key="index">- {{ antibiotic.antibiotic }} </span></p>
      </div>
      <div class="form-group row">
        <label for="ast_status" class="col-form-label col-md-2">Processing status</label>
        <div class="col-md-4">
          <select class="form-control"
                  name="ast_status"
                  v-model="ast_status"
                  v-validate="'required'"
                  :class="{'is-invalid':errors.has('ast_status')}">
            <option></option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
            <option value="Pending">Pending</option>
            <option value="Disagreement">Disagreement</option>
            <option value="Provisional Approval">Provisional Approval</option>
            <option value="Non-Compliance">Non-Compliance</option>
          </select>
          <div class="invalid-feedback">
            Required
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="ast_review" class="col-form-label col-md-2">HIC Review</label>
        <div class="col-md-6">
          <textarea v-model="ast_review"
                    name="ast_review"
                    v-validate="'required'"
                    :class="{'is-invalid': errors.has('ast_review')}"
                    rows=8 class="form-control"></textarea>
          <div class="invalid-feedback">
            Required
          </div>
          <div class="mt-3">
            <button v-on:click="addTodayDateString()" type="button" class="btn-hashtag btn btn-outline-primary btn-sm m-1">+ Date</button>
            <button v-for="(hashtag, index) in hashtags"
              :key="hashtag"
              v-on:click="addHashTag(hashtag)"
              type="button" class="btn btn-outline-primary btn-sm btn-hashtag m-1">{{ hashtag }}</button>
          </div>
        </div>
      </div>
      <button class="btn btn-primary"
              >Save</button>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import axiosConfig from '@/common/axiosConfig'
import router from '@/router'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { format } from 'date-fns'

export default {
  name: 'RequestProcess',
  data () {
    return {
      patient: {
        name: null,
        id: null,
        hospital_id: null
      },
      antibiotics: [],
      ast_status: null,
      ast_review: null,
      hashtags: [
        'Empirical',
        'Culture Appropriate',
        'Cultures Awaited',
        'Colonisation',
        'De-escalated',
        'Not De-escalated',
        'Incorrect Doses',
        'Incorrect Choice',
        'Inappropriate Escalation',
        'Rejected',
        'Narrow spectrum alternatives available',
        'Inappropriate Surgical Prophylaxis',
        'Non-Compliance'
      ]
    }
  },
  computed: {
    ...mapGetters(['currentHospital'])
  },
  methods: {
    setInitialData (data) {
      _.extend(this, _.pick(data, ['patient', 'antibiotics', 'ast_status', 'ast_review']))
    },
    addHashTag (hashtag) {
      if (this.ast_review === null) {
        this.ast_review = ''
      }
      this.ast_review = this.ast_review + ' #' + _.camelCase(hashtag)
    },
    addTodayDateString () {
      const todayString = format(new Date(), 'yyyy-MM-dd' + ': ')
      this.ast_review = this.ast_review === null
        ? todayString
        : this.ast_review + '\n\n' + todayString
    },
    validateAndSave () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.save()
        }
      })
    },
    save () {
      var data = {
        ast_review: this.ast_review,
        ast_status: this.ast_status
      }
      var requestId = this.$route.params.requestId
      axios.put(`hospital/${this.currentHospital.code}/antibiotic_authorization/${requestId}/ast_process/`, data, axiosConfig)
        .then(response => {
          router.push({
            name: 'RequestDetail',
            params: {
              hospital: this.currentHospital.code,
              requestId: requestId
            }
          })
        }).catch(error => {
          console.log(error)
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to).then(response => {
      next(vm => vm.setInitialData(response.data))
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to).then(response => {
      this.setInitialData(response.data)
      next()
    })
  }
}

var getData = (route) => {
  return axios.get(`hospital/${route.params.hospital}/antibiotic_authorization/${route.params.requestId}/`, axiosConfig)
}
</script>
<style scoped>
.btn.btn-sm.btn-hashtag {
  padding: 0px 4px;
  font-size: 90%;
}
</style>
